import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import { IPage } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/IPage";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { UserOnboarding } from "@/interfaces/onboarding-interfaces/UserOnboarding";
import { LazoCompanyInvitationDetailed } from "@/types/LazoCompanyInvitationDetailed";
import { LazoInvitation, LazoResendInvitation } from "@/types/LazoInvitation";

class LazoInvitationsService {
  path: string;
  publicPath: string;
  constructor(path: string) {
    this.path = path;
    this.publicPath = this.path + "/public";
  }

  sendInvitationToCompany(invitation: LazoInvitation): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.path}/company/invite-user`, invitation);
  }

  resendInvitationToCompany(invitation: LazoResendInvitation): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.path}/company/resend`, invitation);
  }

  createUserForCompany(userInformation: UserOnboarding, invitationExternalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.publicPath}/company/register-user?invitationExternalId=${invitationExternalId}`, userInformation);
  }

  checkInvitationWasUsed(invitationExternalId: boolean): Promise<ApiResponseV2<boolean>> {
    return HttpClientV2.get(`${this.publicPath}/used?invitationExternalId=${invitationExternalId}`);
  }

  getDetailedCompanyInvitationInfo(invitationExternalId: string): Promise<ApiResponseV2<LazoCompanyInvitationDetailed>> {
    return HttpClientV2.get(`${this.publicPath}/check/user-to-company?invitationExternalId=${invitationExternalId}`);
  }

  rejectInvitation(invitationExternalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.publicPath}/user-reject?invitationExternalId=${invitationExternalId}`, {});
  }

  updateInvitationBlockedStatus(invitationExternalId: string, blocked: boolean): Promise<ApiResponseV2<string>> {
    return HttpClientV2.put(`${this.path}/blocked-status?invitationExternalId=${invitationExternalId}&blocked=${blocked}`, {});
  }

  updateAssignPendingTasksOnAcceptance(
    invitationExternalId: string,
    assignPendingTasksOnAcceptance: boolean
  ): Promise<ApiResponseV2<LazoCompanyInvitationDetailed>> {
    return HttpClientV2.put(`${this.path}/${invitationExternalId}/assign-pending-tasks`, {
      assignPendingTasksOnAcceptance,
    });
  }

  acceptCompanyInvitation(userExternalId: string, tenantExternalId: string, invitationExternalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.publicPath}/company/user-accept?invitationExternalId=${invitationExternalId}`, {
      userExternalId,
      tenantExternalId,
    });
  }

  getInvitationsByTenantExternalIdPaged(
    page: number,
    pageSize: number,
    tenantExternalId: string
  ): Promise<ApiResponseV2<IPage<LazoCompanyInvitationDetailed>>> {
    const url = `${this.publicPath}/invitations?page=${page}&pageSize=${pageSize}&tenantExternalId=${tenantExternalId}`;
    return HttpClientV2.get(url);
  }
}

export default new LazoInvitationsService("/api/invitations");
